
import IstProgress from '../../common/components/progress.jsx'
import Constants from '../../common/components/constants.jsx'

import GlobalMenu from './global-menu.jsx'

import '../../sass/elemental.css'
import React, { useEffect, useState } from "react";
import {apiAccess} from "../../common/components/AxiosWrapper";


function App (props) {
    const [isLoading, setIsLoading] = useState(true)
    const [categories, setCategories] = useState([])

    const loadCategoryList =() =>{
        apiAccess.get(
            Constants.URLs.GET_ALL_CATEGORIES)
            .then((response) => {
                const successJson = response.data;
                const categories = successJson.hasOwnProperty('data') ? successJson.data : [];
                setIsLoading(false)
                setCategories(categories)
                console.log(categories)
            })
            .catch((error) => {
                console.log(error);
            });
    }

    useEffect(()=>{
        loadCategoryList()
    },[])

    console.info('current user: ', props.auth);
    return(
        <div>
            {isLoading  ?
                        <div className="main-flex">
                            <IstProgress />
                        </div>
                        :
                        <div className="main-flex">
                            <GlobalMenu
                            menu={categories}
                            auth={props.auth} />
                            <div id="contents_area">
                                {props.children && React.cloneElement(props.children, {
                                    auth: props.auth,
                                    categories: categories,
                                    loadCategoryList: () => { loadCategoryList(); }
                                })}
                            </div>
                        </div>
            }
        </div>
    )

}

export default App;
